import { styled } from '@mui/material';
import type { ReactNode } from 'react';

import { SUB_TOPIC_LIST_CONTAINER } from './subTopicListContainer';

type Props = {
  children: ReactNode;
  'aria-label': string;
  'aria-busy'?: boolean;
  'data-testid'?: string;
};

const List = styled('ul')(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  containerType: 'inline-size',
  containerName: SUB_TOPIC_LIST_CONTAINER,
  '& > li + li': {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

/**
 * List of `SubTopicListItem` rows separated by hairline dividers.
 * Rows stack on narrow widths and put the state on the name's line once the list itself is wide
 * enough (container query, not viewport).
 */
export function SubTopicList(props: Props) {
  return (
    <List
      aria-label={props['aria-label']}
      aria-busy={props['aria-busy']}
      data-testid={props['data-testid'] ?? 'sub-topic-list'}
    >
      {props.children}
    </List>
  );
}

export type { Props as SubTopicListProps };
